export const language = {
    labels: {
        name: "Nome",
        language: "Indioma",
        languages: "Idiomas",
        audio: "Aúdio",
        subtitle: "Legenda",
        interface: "Interface",
        edit_language: "Editar Idioma",
    },
    placeholders: {
        name: "Informe o nome do idioma",
    },
    switches: {
        audio: "Aúdio",
        subtitle: "Legenda",
        interface: "Interface",
    },
    modals: {
        titles: {
            add_language: "Adicionar Idioma",
            edit_language: "Editar Idioma",
            del_language: "Excluir Idioma",
        },
        messages: {
            del_language: "Você deseja mesmo excluir o idioma <strong>{name}</strong>?",
        },
    },
    texts: {
    },
};
